import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Input, TextArea } from 'components/ValidationInput';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';

import * as Vali from 'helper/validator-helper';
import * as MEnum from './maintenance-enums';

import MaintenanceServices from './services';
import './maintenance.scss';

export class SpecificMaintenanceTaskView extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      history: PropTypes.object,
      projectId: PropTypes.string,
      lotList: PropTypes.array,
      onCancel: PropTypes.func,
      id: PropTypes.string,
      inventoryItem: PropTypes.string,
      maintenanceTaskDetail: PropTypes.object
    }

    constructor(props) {
      super(props);

      this.maintenanceService = new MaintenanceServices(this.props.dispatch);

      this.state = {
        activeStep: 1,
        searchText: '',

        name: '',
        description: '',

        planList: []
        // planList: [
        //   {
        //     'planName': 'The first plan',
        //     'lots': [
        //       {
        //         'id': '237ec5221ed74e5994ad5730ca2eef06',
        //         'name': 'LOT#101',
        //         'streetAddress': '855 VVT',
        //         'checked': true
        //       },
        //       {
        //         'id': '48a104d31c514d9eb88280d312f9373e',
        //         'name': 'llot #102',
        //         'streetAddress': '696 CH BLK',
        //         'checked': false
        //       }
        //     ]
        //   }
        // ],

        // inventoryItem: {
        //   id: '111',
        //   name: 'THERMADOR 30 MASTERPIECE'
        // }
      };
    }

    componentDidMount() {
      this.maintenanceService.getSpecificTaskById(this.props.id, this.props.projectId, this.props.inventoryItem.id);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.maintenanceTaskDetail) {
        this.textInputs.name.value = nextProps.maintenanceTaskDetail.name;
        this.textInputs.description.value = nextProps.maintenanceTaskDetail.description;
        this.applyToAllLot = !nextProps.maintenanceTaskDetail.plans.some(pl => pl.lots.some(l => l.checked === false));
      }
    }

    // user events
    onClickSaveButton = (e) => {
      e.preventDefault();

      this.maintenanceService.updateSpecifictTaskById(
        this.props.id,
        this.textInputs.name.value,
        this.textInputs.description.value,
        this.props.onCancel
      );
    }

    onTextInputChange = (inputName, obj) => {
      let hasError = false;

      if (!this.textInputs) {
        this.textInputs = {};
      }

      this.textInputs[inputName] = obj;

      for (let key in this.textInputs) {
        if (this.textInputs[key].error) {
          hasError = true;
          break;
        }
      }

      this.setState({ hasError: hasError });
    }

    onChangeSearchText = (e) => {
      this.setState({searchText: e.target.value});
    }

    switchToStep = (stepNumber) => {
      this.setState({activeStep: stepNumber});
    }

    onKeyPressSearchText = (e) => {
      if (e.key === 'Enter') {
        this.onSearch();
      }
    }
    // end user events

    // helpers
    getLotsInPlan = (plan) => {
      return plan.lots
        .map(e => ({ id: e.id, label: `${e.name}, ${e.streetAddress}`, checked: e.checked }))
        .filter(e => e.label.toLowerCase().includes(this.state.searchText.toLowerCase()));
    }
    // end helpers

    // renders
    renderLotsList = (lotList) => {
      return lotList.map(e =>
        <li key={e.id}>
          <CheckBoxSingle className='checkbox-default ckb-lot-pick' value={e.id} label={e.label} disabled={true} checked={e.checked}/>
        </li>
      );
    }

    renderPlanList() {
      return (
        <div className='lot-list'>
          {
            this.props.maintenanceTaskDetail.plans.map((plan, index) => {
              let lotsList = this.getLotsInPlan(plan);

              if (lotsList.length === 0) { return null; }
              return (
                <div className='plan-item' key={index}>
                  <div className='plan-name'>{plan.name}</div>
                  <ul>
                    {this.renderLotsList(lotsList)}
                  </ul>
                </div>
              );
            })
          }
        </div>
      );
    }

    renderRepeatInfo(taskDetail) {
      return (
        <React.Fragment>
          <div className='row' style={{marginTop: '10px'}}>
            <div className='col-md-12'>
              {`Remind ${MEnum.REPEAT_PERIOD_LIST[taskDetail.repeatType].description}` +
              ` ${MEnum.REPEAT_END_LIST[taskDetail.repeatTypeEnd].description}` +
              ` ${MEnum.REPEAT_START_SPECIFIC_LIST[taskDetail.repeatTypeStart].description}.`}
            </div>
          </div>
        </React.Fragment>
      );
    }

    render() {
      return (
        <React.Fragment>
          <div className='step-wrapper'>
            <div className='step'>
              <div className={`step-number ${this.state.activeStep === 1 ? 'active' : ''}`} onClick={() => this.switchToStep(1)}>1</div>
              <span className='step-header'>Name & Recurring pattern</span>
            </div>
            <div style={{ display: this.state.activeStep === 1 ? 'block' : 'none' }}>
              <div className='form-group'>
                <label htmlFor='name'>Name<span className='text-danger'>*</span></label>
                <Input
                  type='text'
                  name='name'
                  initValue={this.textInputs && this.textInputs.name && this.textInputs.name.value}
                  onChange={e => this.onTextInputChange('name', e)}
                  validators={[Vali.required]}
                />
              </div>
              <div className='form-group'>
                <label htmlFor='description'>Description</label>
                <TextArea
                  name='description'
                  rows={5}
                  initValue={this.textInputs && this.textInputs.name && this.textInputs.description.value}
                  onChange={e => this.onTextInputChange('description', e)}
                />
              </div>
              {
                this.props.maintenanceTaskDetail &&
                this.renderRepeatInfo(this.props.maintenanceTaskDetail)
              }
            </div>
            <div className='step'>
              <div className={`step-number ${this.state.activeStep === 2 ? 'active' : ''}`} onClick={() => this.switchToStep(2)}>2</div>
              <span className='step-header'>Apply to the whole project or limit to some lots </span>
            </div>
            {
              this.state.activeStep !== 2 &&
              <div style={{marginLeft: 3}}>Select lots to apply this maintenance task (Optional)</div>
            }
            {
              this.state.activeStep === 2 &&
              <React.Fragment>
                <CheckBoxSingle
                  name='apply_all'
                  ref='isAppliedAll'
                  disabled={true}
                  className='checkbox-default'
                  checked={this.applyToAllLot}
                  style={{margin: 0, bottom: 10, textOverflow: 'ellipsis', overflow: 'hidden'}}
                  label='Apply to this maintenance schedule to the whole project'
                />
                {
                  this.state.activeStep === 2 &&
                  <div className='row'>
                    <div className='col-md-6'>
                      <div style={{margin: '10px 0'}}>
                        <b>Pick lots to apply this maintenance schedule</b>
                      </div>
                      <div className='input-group' style={{margin: '10px 0'}}>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Lot# / Street address'
                          value={this.state.searchText}
                          onChange={this.onChangeSearchText}
                          onKeyPress={this.onKeyPressSearchText}
                        />
                        <span className='input-group-btn'>
                          <button
                            type='button'
                            className='btn btn-secondary'
                            style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}>
                            <span className='fa fa-search' />
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                }
                {this.renderPlanList()}
              </React.Fragment>
            }
            <div className='step'>
              <div className={`step-number ${this.state.activeStep === 3 ? 'active' : ''}`} onClick={() => this.switchToStep(3)}>3</div>
              <span className='step-header'>Home inventory item</span>
            </div>
            {
              this.state.activeStep !== 3 &&
              <div style={{marginLeft: 3}}>Associated inventory item</div>
            }
            {
              this.state.activeStep === 3 &&
              <Link target='_blank' to={this.maintenanceService.buildUrlToInventoryItem(this.props.projectId, this.props.inventoryItem.id)}>
                {this.props.inventoryItem.name}
              </Link>
            }
          </div>
          <div style={{marginTop: 20}}>
            <div className='col-md-12 col-xs-12'>
              <span className='btn btn-siteone-default' onClick={this.props.onCancel}>Cancel</span>
              <button
                type='submit'
                className='btn btn-primary btn-siteone'
                disabled={this.state.hasError ? 'disabled' : null}
                onClick={this.onClickSaveButton}>
                    Save
              </button>
            </div>
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    maintenanceTaskDetail: state.ProjectStore.MaintenanceTaskDetail
  };
};

export default connect(mapStateToProps)(SpecificMaintenanceTaskView);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-specific-view.js